module.exports = __webpack_public_path__ + "static/media/hz-adv-1.358e8f1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/aigc/assets/hz-adv-1.mp4
// module id = ldZM
// module chunks = 130